<header class="topbar" [class.topbar--scrolled]="contentScrolled()">
  @if (topbarConfig(); as config) {
    <app-topbar-title class="topbar__title" [icon]="config.icon" [label]="config.label | transloco" />
  } @else {
    <span class="topbar__title"></span>
  }

  @if (canCreateOpportunity()) {
    <app-topbar-actions
      class="topbar__action"
      [buttonIcon]="'icons/phosphor/regular/plus.svg'"
      [buttonLabel]="'nav.topbar.newOpportunity' | transloco"
      (buttonClick)="onCreateOpportunity()"
    />
  }
</header>
